import { getTabPanelElement } from "Shared/Components/Tabs/Helpers/getTabPanelElement";
import { useNavigateTabs } from "Shared/Components/Tabs/Hooks/useNavigateTabs";
import type {
	TabType,
	useTabsHooksPropsType,
	useTabsHookType,
} from "Shared/Components/Tabs/Types/TabType";
import { TabContext, TabList } from "@mui/lab";
import { Tab } from "@mui/material";
import { type FC, Fragment } from "react";

export type TabsProps = {
	value: string;
	tabs: TabType[];
	mapItem?: (tabs: TabType) => React.JSX.Element;
	hookFunction?: (args: useTabsHooksPropsType) => useTabsHookType;
};

export const Tabs: FC<TabsProps> = (props) => {
	const { value, tabs, mapItem, hookFunction = useNavigateTabs } = props;
	const { active, onChange } = hookFunction({ tabs, currentTab: value });

	return (
		<TabContext value={active}>
			<TabList
				onChange={onChange}
				variant="scrollable"
				scrollButtons="auto"
				allowScrollButtonsMobile
				orientation="horizontal"
			>
				{tabs.map(
					(tab) =>
						!tab.isHidden && (
							<Tab key={tab.index} value={tab.index} label={tab.label} />
						),
				)}
			</TabList>
			{tabs.map((tab) => (
				<Fragment key={tab.index}>
					{mapItem ? mapItem(tab) : getTabPanelElement(tab)}
				</Fragment>
			))}
		</TabContext>
	);
};
